import { h } from '@stencil/core';
import { isModifiedEvent } from '../utils/dom-utils.mjs';
import { getInternalRouter } from '../utils/getInternalRouter.mjs';

var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/**
 * Link to a url.
 * @usage ./Link.usage.md
 */
const Link = (_a, children) => {
    var { element: Element = 'a', url, urlMatch = url, exact, strict, external = false, forceRefresh = false, updateScroll = true, activeClass = 'link-active', class: classes = {}, disabled, onClick } = _a, props = __rest(_a, ["element", "url", "urlMatch", "exact", "strict", "external", "forceRefresh", "updateScroll", "activeClass", "class", "disabled", "onClick"]);
    const router = getInternalRouter();
    const match = router.match({
        path: urlMatch,
        strict,
        exact,
    });
    return (h(Element, Object.assign({ href: disabled || url == null
            ? undefined
            : external
                ? url
                : router.getUrl(url), class: Object.assign({ [activeClass]: !!match }, (typeof classes === 'string'
            ? { [classes]: true }
            : classes)), disabled: disabled, "aria-disabled": disabled, "data-router": 'yes', onClick: (e) => {
            const cancel = onClick === null || onClick === void 0 ? void 0 : onClick(e);
            if (cancel === false ||
                disabled ||
                external ||
                forceRefresh ||
                isModifiedEvent(e) ||
                url == null) {
                return;
            }
            e.preventDefault();
            const href = router.getUrl(url);
            router.history.push(href, undefined, updateScroll);
        } }, props), children));
};

export { Link };
